// Shared by the Apollo keyArgs and the activity-feed cache so the two keys never drift.
export const getEventScopeCacheKey = (scope: {
  objectId: string
  objectType: string
  parentRowId?: string | null
  includeRowEvents?: boolean | null
}): string => {
  return [
    scope.objectId,
    scope.objectType,
    scope.parentRowId ?? '',
    scope.includeRowEvents ? 'rows' : '',
  ].join('-')
}
